export default __webpack_public_path__ + "images/42_2_image.jpg";